import React, {useState, useEffect} from "react"
import puzzleAnswerData from "../puzzleAnswerData"

function BriefcaseInput(props) {
    const [lockValues, setLockValues] = useState({
        caseOne: 0,
        caseTwo: 0,
        caseThree: 0,
        caseFour: 0,
        caseFive: 0,
        caseSix: 0
    })
    const [briefcaseCode] = useState(puzzleAnswerData[5].briefcaseCode)
    
    const briefcaseDataLeft = [
        {
            id: 1,
            valueId: lockValues.caseOne,
            name: "caseOne",
        },
        {
            id: 2,
            valueId: lockValues.caseTwo,
            name: "caseTwo",
        },
        {
            id: 3,
            valueId: lockValues.caseThree,
            name: "caseThree"
        }
    ]
    const briefcaseDataRight = [
        {
            id: 4,
            valueId: lockValues.caseFour,
            name: "caseFour"
        },
        {
            id: 5,
            valueId: lockValues.caseFive,
            name: "caseFive"
        },
        {
            id: 6,
            valueId: lockValues.caseSix,
            name: "caseSix"
        }
    ]
    
    function increaseNumber(event) {
        const {name, value} = event.target
        const updateIncrease = value < 9 ? parseInt(value) + 1 : 0
        setLockValues({
            ...lockValues,
            [name]: updateIncrease
        })
    }
    
    function decreaseNumber(event) {
        const {name, value} = event.target
        const updateDecrease = value > 0 ? parseInt(value) - 1 : 9
        setLockValues({
            ...lockValues,
            [name]: updateDecrease
        })
    }
    
    useEffect(() => {
        const lockInput = String(lockValues.caseOne) + String(lockValues.caseTwo) + String(lockValues.caseThree) + String(lockValues.caseFour) + String(lockValues.caseFive) + String(lockValues.caseSix)
        
        if (lockInput === briefcaseCode) { setTimeout(() => completePuzzle(), 250) }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [lockValues, briefcaseCode])
        
    
    function completePuzzle() {
            document.getElementById("overlay").style.opacity = "100%"
            const show = "on"
            const text = "Inside the briefcase is the dazzling Paradox Diamond! Congratulations detectives, you have solved the case."
            const trigger = "briefcase"
            const complete = true
            props.callBackOverlay(show, text, trigger)
            props.callBackStatus(trigger, complete)
    }
    
    const locksLeft = briefcaseDataLeft.map(lock => {
        return (
            <div key={lock.id} className="singleLock">
                <button className="arrowButton upArrow" name={lock.name} value={lock.valueId} onClick={increaseNumber}></button>
                <div className="numberDisplay">
                    <h1>{lock.valueId}</h1>
                </div>
                <button className="arrowButton downArrow" name={lock.name} value={lock.valueId} onClick={decreaseNumber}></button>
            </div>
        )
    })
    
    const locksRight = briefcaseDataRight.map(lock => {
        return (
            <div key={lock.id} className="singleLock">
                <button className="arrowButton upArrow" name={lock.name} value={lock.valueId} onClick={increaseNumber}></button>
                <div className="numberDisplay">
                    <h1>{lock.valueId}</h1>
                </div>
                <button className="arrowButton downArrow" name={lock.name} value={lock.valueId} onClick={decreaseNumber}></button>
            </div>
        )
    })
    
    return (
        <div className="briefcaseTopDownWrapper">
            <div className="briefcaseLockWrapper leftLock">
                {locksLeft}
            </div>
            <div className="topDownHandle"></div>
            <div className="briefcaseLockWrapper rightLock">
                {locksRight}
            </div>
        </div>
    )
}

export default BriefcaseInput